module.exports = __webpack_public_path__ + "static/media/down-arrow.f1166156.svg";